import { createFetchTypes } from '../../utils/createFetchTypes';

export const CREATE_CLINIC = 'CREATE_CLINIC';
export const UPDATE_CLINIC = 'UPDATE_CLINIC';

// ************* createFetchType

export const GET_CLINICS = createFetchTypes('GET_CLINICS');
